// extracted by mini-css-extract-plugin
export var errorIcon = "_ms-1";
export var nameLogo = "_ms-0";